import { yup } from '@/libs/yup';
import { schema as permissionSchema } from '../edit/parts/PermissionForm/schema';

export const schema = permissionSchema;

export type Schema = yup.InferType<typeof schema>;
